import { memo } from 'react';
import { Ownership, RestrictionType } from '@uniqkey-backend-organization-web/api-client';
import {
  Avatar, B1, ClockIcon, GlobeIcon, LocationIcon, S1, S3, ProfileIcon, GroupsIcon,
} from '@uniqkey-frontend/shared-app';
import { TSelectionOptionType } from '../SelectionModalOption';

interface IAvatarWithIconProps {
  isEnabled?: boolean;
  avatarSize: number;
  iconSize: number;
  type: TSelectionOptionType;
}

const ICONS = {
  [RestrictionType.IpAddress]: GlobeIcon,
  [RestrictionType.Time]: ClockIcon,
  [RestrictionType.Location]: LocationIcon,
  [Ownership.Employees]: ProfileIcon,
  [Ownership.Groups]: GroupsIcon,
};

const AvatarWithIcon = (props: IAvatarWithIconProps) => {
  const {
    type, isEnabled = true, avatarSize, iconSize,
  } = props;
  const Icon = ICONS[type];
  return (
    <Avatar width={avatarSize} height={avatarSize} backgroundColor={isEnabled ? B1 : S3}>
      <Icon width={iconSize} height={iconSize} color={S1} />
    </Avatar>
  );
};

export default memo(AvatarWithIcon);
